import React from 'react';
import SubscriptionLink from '../components/subscription-link';

const SubscriptionLinkBlock = (props) => <SubscriptionLink {...props} />;

export default SubscriptionLinkBlock;
